import React from "react";

interface CompassModalProps {
  isOpen: boolean;
  language: "ka" | "en";
  angle: number; // Угол поворота стрелки в градусах (0 = вверх, 90 = вправо, 180 = вниз, 270 = влево)
  position: { x: number; y: number }; // Позиция тултипа на экране
  tileSize: number; // Размер клетки
  onClose: () => void;
}

export const CompassModal: React.FC<CompassModalProps> = ({
  isOpen,
  language,
  angle,
  position,
  tileSize,
  onClose,
}) => {
  if (!isOpen) return null;

  const compassText = {
    ka: {
      message: "მიმართულება უახლოეს ყუთამდე",
    },
    en: {
      message: "Direction to the nearest chest",
    },
  };

  // Размер компаса = 2x размер клетки
  const compassSize = tileSize * 2;

  return (
    <>
      {/* Затемняющий фон */}
      <div
        className="fixed inset-0 z-40 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Картинка компаса в клетке */}
      <div
        className="fixed z-50 pointer-events-none"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: "translate(-50%, -50%)",
        }}
      >
        <img
          src="/models/treasure-hunt/ui/compass.png"
          alt="Compass"
          className="drop-shadow-2xl animate-[compassFadeIn_0.3s_ease-out]"
          style={{
            width: `${compassSize}px`,
            height: `${compassSize}px`,
            imageRendering: "pixelated",
            transform: `rotate(${angle}deg)`,
            transition: "transform 0.5s ease-out",
          }}
        />
      </div>

      {/* Тултип с текстом ниже клетки */}
      <div
        className="fixed z-50 pointer-events-none"
        style={{
          left: `${position.x}px`,
          top: `${position.y + tileSize / 2 + 16}px`,
          transform: "translate(-50%, 0)",
        }}
      >
        <div
          className="bg-amber-100 rounded-xl border-4 border-amber-800 shadow-2xl p-3 flex flex-col gap-2 pointer-events-auto animate-[tooltipFadeIn_0.3s_ease-out]"
          style={{
            fontFamily: "MinecraftGeorgian, monospace",
            maxWidth: "200px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Текст подсказки */}
          <p className="text-amber-900 text-xs font-semibold text-center">
            {compassText[language].message}
          </p>

          {/* Кнопка закрытия */}
          <button
            onClick={onClose}
            className="px-3 py-1.5 bg-gradient-to-b from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-bold text-xs rounded-none border-2 border-amber-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.5)] transition-all active:translate-y-0.5"
            style={{ fontFamily: "MinecraftGeorgian, monospace" }}
          >
            OK
          </button>
        </div>
      </div>

      <style>{`
        @keyframes compassFadeIn {
          from {
            opacity: 0;
            transform: rotate(${angle}deg) scale(0.5);
          }
          to {
            opacity: 1;
            transform: rotate(${angle}deg) scale(1);
          }
        }

        @keyframes tooltipFadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </>
  );
};
